/**
 * 投放平台的单一事实来源（admin 用）。纯标签，无业务逻辑含义：
 * 仅用于「链接管理」列表展示与筛选，不参与任何规则判定。
 * worker 用 PLATFORM_IDS 做创建/更新校验，admin 用 PLATFORMS 渲染下拉与 Badge。
 */
export const PLATFORM_IDS = ['tt', 'fb', 'google', 'other'] as const;

export type PlatformId = (typeof PLATFORM_IDS)[number];

export interface PlatformDescriptor {
  id: PlatformId;
  /** 下拉的完整标签 */
  label: string;
  /** 列表 Badge 用的短标签 */
  shortLabel: string;
}

export const PLATFORMS: readonly PlatformDescriptor[] = [
  { id: 'tt', label: 'TikTok (TT)', shortLabel: 'TT' },
  { id: 'fb', label: 'Facebook (FB)', shortLabel: 'FB' },
  { id: 'google', label: 'Google (GG)', shortLabel: 'GG' },
  // 通用兜底：其它未细分的投放来源
  { id: 'other', label: '其他 (Other)', shortLabel: '其他' },
];

export function platformById(id: string): PlatformDescriptor | undefined {
  return PLATFORMS.find((p) => p.id === id);
}
